'use client';

import { useCallback } from 'react';
import { isTargetingCategoryActive } from '$util/oneTrust';
import { useGA4Tracking } from '$util/hooks/useGA4Tracking';
import { ga4Event } from '@/util/ga4Analytics';

/*
 * This was the original script provided by the agency, see below for the migration to GA4
 * <!--
 *    Start of Floodlight Tag: Please do not remove
 *    Activity name of this tag: f-traffic-counter-brand-std-allpage-04-2025--
 *    URL of the webpage where the tag is expected to be placed: https://www.fixter.fr/
 *    This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
 *    Creation Date: 04/10/2025
 *    -->
 *    <script type="text/javascript">
 *    var axel = Math.random() + "";
 *    var a = axel * 10000000000000;
 *    document.write('<img src="https://ad.doubleclick.net/ddm/activity/src=9393940;type=local_co;cat=f-tra0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" alt=""/>');
 *    </script>
 *    <noscript>
 *    <img src="https://ad.doubleclick.net/ddm/activity/src=9393940;type=local_co;cat=f-tra0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>
 *    </noscript>
 * <!-- End of Floodlight Tag: Please do not remove -->
 */

interface FloodlightLandingPixelProps {
  floodlightId: string;
}

/**
 * Based on the script above provided by the agency, we've did our best to migrate Floodlight to GA4 as recommended by Google.
 * @see https://support.google.com/campaignmanager/answer/7564930
 *
 * We mapped the `src=` by using "Fields in event snippets for counter tags" => "Example event snippet for counter - standard activities" reference by Google.
 * @see https://support.google.com/campaignmanager/answer/7554821?sjid=14340977532704800327-EU#fields&zippy=%2Ccustom-fields%2Cfields-in-event-snippets-for-enhanced-conversions%2Cfields-in-event-snippets-for-sales-tags%2Cfields-in-event-snippets-for-counter-tags%2Cfields-in-all-event-snippets%2Cfields-in-the-global-snippet%2Cexample-event-snippet-for-counter---unique-activities%2Cexample-event-snippet-for-counter---per-session-activities%2Cexample-event-snippet-for-counter---standard-activities
 */

export function FloodlightLandingPixel({ floodlightId }: FloodlightLandingPixelProps): null {
  const floodlightTrackPage = useCallback(
    () =>
      isTargetingCategoryActive() &&
      ga4Event('conversion', {
        allow_custom_scripts: true,
        send_to: `${floodlightId}/local_co/f-tra0+standard`,
      }),
    [floodlightId]
  );

  useGA4Tracking(floodlightTrackPage);

  return null;
}
